import MapInfoBox from './MapInfoBox';

export default MapInfoBox;
